import { Link, useLocation } from 'react-router-dom';
import { Stack, NavLink, Paper, Text, ThemeIcon, Group, Box } from '@mantine/core';
import {
  IconDashboard,
  IconCar,
  IconTool,
  IconReportAnalytics,
} from '@tabler/icons-react';

const menuItems = [
  { label: 'Özet Durum', icon: IconDashboard, link: '/dashboard' },
  { label: 'Araç Listesi', icon: IconCar, link: '/vehicles' },
  { label: 'Bakım Takvimi', icon: IconTool, link: '/maintenance' },
  { label: 'Raporlar', icon: IconReportAnalytics, link: '/reports' },
  { label: 'Araç Arşiv', icon: IconReportAnalytics, link: '/archive-vehicles' },
];

export default function Sidebar({ onClose }) {
  const userRole = localStorage.getItem('user_role');
  const location = useLocation();

  const filteredItems = menuItems.filter((item) => {
    if (item.requiredRole && item.requiredRole !== userRole) {
      return false;
    }
    return true;
  });

  return (
    <Stack gap="lg">
      <Paper
        radius="xl"
        p="md"
        style={{
          background:
            'linear-gradient(135deg, rgba(15,23,42,0.98) 0%, rgba(30,41,59,0.96) 50%, rgba(37,99,235,0.90) 100%)',
          color: 'white',
          border: '1px solid rgba(255,255,255,0.08)',
          boxShadow: '0 14px 34px rgba(15,23,42,0.18)',
          overflow: 'hidden',
          position: 'relative',
        }}
      >
        <Box
          style={{
            position: 'absolute',
            top: -40,
            right: -40,
            width: 110,
            height: 110,
            borderRadius: '50%',
            background: 'rgba(255,255,255,0.08)',
          }}
        />
        <Group wrap="nowrap" style={{ position: 'relative', zIndex: 1 }}>
          <ThemeIcon
            size={46}
            radius="xl"
            variant="white"
            color="rgba(255,255,255,0.12)"
          >
            <IconCar size={24} color="black" />
          </ThemeIcon>

          <div>
            <Text fw={800} size="md" c="white">
              Araç Filosu
            </Text>
            <Text size="xs" c="rgba(255,255,255,0.72)">
              Operasyon ve takip paneli
            </Text>
          </div>
        </Group>
      </Paper>

      <Paper
        withBorder
        radius="xl"
        p="xs"
        style={{
          background: 'linear-gradient(180deg, #ffffff 0%, #f8fafc 100%)',
          boxShadow: '0 10px 30px rgba(15,23,42,0.05)',
        }}
      >
        <Stack gap={6}>
          {filteredItems.map((item) => {
            const isActive = location.pathname.startsWith(item.link);

            return (
              <NavLink
                key={item.label}
                component={Link}
                to={item.link}
                label={item.label}
                description={isActive ? 'Aktif sayfa' : undefined}
                leftSection={
                  <ThemeIcon
                    size={34}
                    radius="xl"
                    variant={isActive ? 'filled' : 'light'}
                    color={isActive ? 'blue' : 'gray'}
                  >
                    <item.icon size={18} stroke={isActive ? 2 : 1.7} />
                  </ThemeIcon>
                }
                onClick={onClose}
                active={isActive}
                styles={{
                  root: {
                    borderRadius: 16,
                    paddingBlock: 8,
                    transition: 'all 0.2s ease',
                    border: isActive
                      ? '1px solid rgba(59,130,246,0.18)'
                      : '1px solid transparent',
                    background: isActive
                      ? 'linear-gradient(135deg, rgba(239,246,255,1) 0%, rgba(219,234,254,0.85) 100%)'
                      : 'transparent',
                    boxShadow: isActive
                      ? '0 10px 25px rgba(59,130,246,0.10)'
                      : 'none',
                  },
                  label: {
                    fontWeight: isActive ? 800 : 600,
                    color: isActive
                      ? 'var(--mantine-color-blue-8)'
                      : 'var(--mantine-color-gray-8)',
                  },
                  description: {
                    color: isActive
                      ? 'var(--mantine-color-blue-6)'
                      : 'var(--mantine-color-gray-5)',
                  },
                }}
              />
            );
          })}
        </Stack>
      </Paper>
    </Stack>
  );
}